module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/rE66Xj/tc-custom/9781429966283.jpg?1737746743653",
      "alt": "This image is the cover for the book The Thirteenth, Vampire Huntress Legend Series"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Thirteenth, Vampire Huntress Legend Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("The Thirteenth")]), _vm._v(" is the mind-blowing finale to the Vampire Huntress Legend series from bestselling author L.A. Banks")]), _c('br'), _c('br'), _vm._v("The entire Neteru Guardian team is on the run, having now been labeled as America's most-wanted terrorists following the gruesome demon battle that felled the Washington Monument and crashed the front doors of the White House. The Anti-Christ is positioned for emergence, the powers of darkness have released the pale horse of the apocalypse, and half the Neteru team is pregnant. Plagues from hell that ravage the country are being cited as stemming from bio-terrorism. The nation is under martial law. The Neterus and their team are underground. If things weren't bad enough, the Dark Realm breaks the sixth Biblical seal, which plunges the world into perpetual darkness…and irrevocably into the Armageddon.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      L. A. Banks\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0